module.exports = __webpack_public_path__ + "static/media/VideoPlaceholder.289e83f5.svg";